import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo1 from '../../assets/images/logo/01.png'
import SmallScreenNav from '../Home/Mainhomeone/SmallScreenNav'
const Header = () => {
     const [showInput, setShowInput] = useState(false);
   
       const toggleSearch = () => {
           setShowInput((prev) => !prev);
       };
   
    return (
        <div>
            <div id="navigation" className="navigation-main-block-three navigation-three-block">
                <nav className="navbar navbar-expand-lg bg-body-tertiary">
                    <div className="container-fluid">
                        <div className="navbar-logo">
                            <Link className="navbar-brand" to="#" title="">
                                <img src={logo1} className="img-fluid" alt="" />
                            </Link>
                        </div>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle active"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-current="page"
                                    >
                                        Home <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/">
                                                Home Page 01
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/HomeTwo">
                                                Home Page 02
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item active" to="/HomeThree">
                                                Home Page 03
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Homefour">
                                                Home Page 04
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/HomeFive">
                                                Home Page 05
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/HomeSix">
                                                Home Page 06
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Homeseven">
                                                Home Page 07
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/Aboutus" title="">
                                        About
                                    </Link>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Shop <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/Shop">
                                                Shop
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/shop-filter">
                                                Sidebar Shop 01
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/shop-filter2">
                                                Sidebar Shop 02
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/shopdetails">
                                                Shop Details
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Blog <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/Blog">
                                                Blog
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/BlogDetails">
                                                Blog Details
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/Contactus" title="">
                                        Contact
                                    </Link>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Pages <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/Affiliate">
                                                Affiliate
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Career">
                                                Career
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Faq">
                                                Faq
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Error">
                                                404
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div className="d-flex">
                                <ul className="user-search-icons">
                                    <li>
                                        <ul className="home-icon">
                                            <li>
                                                <div className="search-container">
                                                    <button id="search-icon" onClick={toggleSearch}>
                                                        <i className="flaticon-search" />
                                                    </button>
                                                    <input
                                                        type="text"
                                                        id="search-input"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        style={{ display: showInput ? "block" : "none" }}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <Link to="#" title="">
                                                    <i className="flaticon-avatar" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/WishList" title="">
                                                    <i className="flaticon-love" />
                                                    <span className="icon-badge">11</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/Cart" title="">
                                                    <i className="flaticon-bag" />
                                                    <span className="icon-badge">0</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </nav>
            </div>
            <SmallScreenNav />
        </div>
    )
}

export default Header